/* eslint-disable camelcase */
import { toast } from "react-toastify";

import PlantQuotas from "../../../api/plant-quotas";

export const plantQuotas = {
  state: {
    quotas: [],
    initialQuotas: [],
    updatedQuotas: [],
    loading: false,
  },
  reducers: {
    setPlantQuotas(state, payload) {
      return {
        ...state,
        quotas: [...state.quotas, ...payload],
      };
    },
    setInitialQuotas(state, payload){
         return {
            ...state,
            initialQuotas: JSON.parse(JSON.stringify(payload))
          };
    },
    setAddquantity(state, payload) {
      const { indexPlant, indexTurn } = payload

      // const count = state?.quotas[indexTurn]?.plants?.map((item) => Number(item?.total_capacity))
      //               .reduce((total, present) => {
      //                 return total + present}, 0);

      const newArray = [...state.quotas];

      const quota = state.quotas[indexTurn].plants[indexPlant].quota
      newArray[indexTurn].plants[indexPlant].quota = {...quota, quantity: quota.quantity+1}

      return {
        ...state,
        quotas: newArray,
      };
    },
    setSubtractquantity(state, payload) {
      const { indexPlant, indexTurn } = payload

      const newArray = [...state.quotas];

      const quota = state.quotas[indexTurn].plants[indexPlant].quota
      newArray[indexTurn].plants[indexPlant].quota = {...quota, quantity: quota.quantity-1}

      return {
        ...state,
        quotas: newArray,
      };
    },
    setQuantity(state, payload) {
      const { indexTurn, indexPlant, newQuantity } = payload;
      const { quotas } = state;
      quotas[indexTurn].plants[indexPlant].quota.quantity = newQuantity;
      return {
        ...state,
        quotas
      };
    },
    loading(state, payload) {
      return {
        ...state,
        loading: payload.loading,
      };
    },
    setWarning(state, payload) {
      return {
        ...state,
        warning: {
          message: payload?.message,
          data: payload?.data
        }
      }
    },
    setError(state, payload) {
      return {
        ...state,
        error: {
          message: payload?.message,
          data: payload?.data
        }
      }
    },
    clearWarning(state, payload) {
      return {
        ...state,
        warning: undefined
      }
    },
    clearError(state, payload) {
      return {
        ...state,
        error: undefined
      }
    },
    clearStore() {
      return {
        quotas: [],
      };
    },
  },
  effects: (dispatch) => ({
    async saveConfigAsync(payload, rootState) {
      this.loading({ loading: true });
      try {
        const res = await PlantQuotas.add(payload);
    
        this.loading({ loading: false });
        this.setWarning(res?.data?.quotasDatesIssues);
        this.setInitialQuotas(rootState?.plantQuotas?.quotas);
        return {success: true, hasWarning: !!res?.data?.quotasDatesIssues};
      } catch (error) {
        this.loading({ loading: false });
        this.setError(error?.response?.data?.schedulingsDatesIssues)
        toast.error("Ops :( Algo deu errado !");
      }
      return {success: false};
    },

    async loadAsync(payload) {

      try {
        const { idBranch, date } = payload;

        this.loading({ loading: true });
        const res = await PlantQuotas.list(idBranch, date);

        this.clearStore();

        this.setPlantQuotas(res.data);
        this.setInitialQuotas(res.data);

        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Ops :( Algo deu errado !");
      }
    },

    addQuantity(item) {
      return this.setAddquantity(item);
    },
    subtractQuantity(item) {
      return this.setSubtractquantity(item);
    },
    setQuantityAsync(payload) {
      return this.setQuantity(payload);
    },
    async deleteAsync(payload) {
      try {
        this.loading({ loading: true });
        await PlantQuotas.delete(payload);
        const res = await PlantQuotas.listByPlant();
        this.setPlantQuotas(res.data);
        this.setPlantQuotasAUX(res.data);
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Ops :( Algo deu errado !");
      }
    },
  }),
};
